import { BOX_BLUE } from 'box-ui-elements/es/common/variables';
import type { Path } from '../../../types/Item';
import type {
  State,
  ContentPickerState,
  DragDropNewFormFieldState,
} from './builder-type';
import { DEFAULT_EMPTY_FILE_REQUEST, PALETTE_COLORS } from '../../../constants';
import { rawColorHex } from '../../../common/utils/colorHex';

export const ACTION_OPEN_METADATA_PICKER = 'ACTION_OPEN_METADATA_PICKER';
export const ACTION_CLOSE_METADATA_PICKER = 'ACTION_CLOSE_METADATA_PICKER';
export const ACTION_SELECT_METADATA_TEMPLATE =
  'ACTION_SELECT_METADATA_TEMPLATE';
export const ACTION_SHOW_METADATA_FIELDS = 'ACTION_SHOW_METADATA_FIELDS';
export const ACTION_OPEN_FIELD_SELECTOR_DRAWER =
  'ACTION_OPEN_FIELD_SELECTOR_DRAWER';
export const ACTION_CLOSE_FIELD_SELECTOR_DRAWER =
  'ACTION_CLOSE_FIELD_SELECTOR_DRAWER';
export const ACTION_HIDE_METADATA_FIELDS = 'ACTION_HIDE_METADATA_FIELDS';
export const ACTION_CLEAR_METADATA_TEMPLATE = 'ACTION_CLEAR_METADATA_TEMPLATE';

export const ACTION_DELETE_FILE_REQUEST = 'ACTION_DELETE_FILE_REQUEST';
export const ACTION_SELECT_METADATA = 'ACTION_SELECT_METADATA';
export const ACTION_TOGGLE_REQUIRED_FIELD = 'ACTION_TOGGLE_REQUIRED_FIELD';
export const ACTION_ON_FOCUS_ELEMENT = 'ACTION_ON_FOCUS_ELEMENT';
export const ACTION_ON_UNFOCUS_ELEMENT = 'ACTION_ON_UNFOCUS_ELEMENT';
export const ACTION_ON_HELP = 'ACTION_ON_HELP';
export const ACTION_CLOSE_NOTIFICATION = 'ACTION_CLOSE_NOTIFICATION';
export const ACTION_MISMATCHED_VERSION = 'ACTION_MISMATCHED_VERSION';
export const ACTION_REORDER_GROUP_FIELDS = 'ACTION_REORDER_GROUP_FIELDS';
export const ACTION_SET_LABEL = 'ACTION_SET_LABEL';
export const ACTION_SET_DESCRIPTION = 'ACTION_SET_DESCRIPTION';
export const ACTION_SET_DESCRIPTION_EDITABLE =
  'ACTION_SET_DESCRIPTION_EDITABLE';
export const ACTION_REMOVE_DESCRIPTION = 'ACTION_REMOVE_DESCRIPTION';
export const ACTION_DRAGGING_STARTED = 'ACTION_DRAGGING_STARTED';
export const ACTION_DRAGGING_FINISHED = 'ACTION_DRAGGING_FINISHED';
export const ACTION_HAS_SCROLLED_TO_BOTTOM = 'ACTION_HAS_SCROLLED_TO_BOTTOM';
export const FORMS_BUILDER_PREVIEW_WINDOW = 'forms_builder_preview_window';
export const ACTION_UPDATE_LIST_OPTIONS = 'ACTION_UPDATE_LIST_OPTIONS';
export const ACTION_UPDATE_MAXIMUM_SELECTIONS =
  'ACTION_UPDATE_MAXIMUM_SELECTIONS';
export const ACTION_SET_LIST_OPTIONS_ERROR = 'ACTION_SET_LIST_OPTIONS_ERROR';

// Action associated with copy file request
export const ACTION_SEARCH_ITEMS = 'ACTION_SEARCH_ITEMS';
export const ACTION_SEARCH_ITEMS_IN_PROGRESS =
  'ACTION_SEARCH_ITEMS_IN_PROGRESS';
export const ACTION_GET_FOLDER_TREE = 'ACTION_GET_FOLDER_TREE';
export const ACTION_GET_FOLDER_TREE_IN_PROGRESS =
  'ACTION_GET_FOLDER_TREE_IN_PROGRESS';
export const ACTION_CLEAR_CONTENT_PICKER = 'ACTION_CLEAR_CONTENT_PICKER';
export const ACTION_COPY_FILE_REQUEST = 'ACTION_COPY_FILE_REQUEST';
export const ACTION_COPY_FILE_REQUEST_IN_PROGRESS =
  'ACTION_COPY_FILE_REQUEST_IN_PROGRESS';

export const ACTION_CLOSE_THEME_PANEL = 'ACTION_CLOSE_THEME_PANEL';
export const ACTION_OPEN_THEME_PANEL = 'ACTION_OPEN_THEME_PANEL';
export const ACTION_OPEN_SETTINGS_PANEL = 'ACTION_OPEN_SETTINGS_PANEL';
export const ACTION_CLOSE_SETTINGS_PANEL = 'ACTION_CLOSE_SETTINGS_PANEL';
export const ACTION_SELECT_THEME_COLOR = 'ACTION_SELECT_THEME_COLOR';
export const ACTION_SHOW_COLOR_PICKER = 'ACTION_SHOW_COLOR_PICKER';
export const ACTION_COLOR_PICKER_CANCEL = 'ACTION_COLOR_PICKER_CANCEL';
export const ACTION_COLOR_PICKER_CHANGE = 'ACTION_COLOR_PICKER_CHANGE';
export const ACTION_COLOR_PICKER_ADD = 'ACTION_COLOR_PICKER_ADD';
export const ACTION_COLOR_PICKER_ERROR = 'ACTION_COLOR_PICKER_ERROR';

export const ADMIN_COLOR_LOGO = 'ADMIN_COLOR_LOGO';
export const ADMIN_DEFAULT_LOGO = 'ADMIN_DEFAULT_LOGO';
export const ADMIN_BRAND_COLOR = 'ADMIN_BRAND_COLOR';
export const ACTION_NOTIFY_METADATA_TEMPLATE_ERROR =
  'ACTION_NOTIFY_METADATA_TEMPLATE_ERROR';
export const ACTION_NOTIFY_UNSUPPORTED_CHARACTERS_ERROR =
  'ACTION_NOTIFY_UNSUPPORTED_CHARACTERS_ERROR';
export const ACTION_TOGGLE_FILE_REQUEST_ACTIVITY =
  'ACTION_TOGGLE_FILE_REQUEST_ACTIVITY';
export const ACTION_DEACTIVATE_BAD_FILE_REQUEST =
  'ACTION_DEACTIVATE_BAD_FILE_REQUEST';
export const ACTION_NOTIFY_FILE_REQUEST_INACTIVE =
  'ACTION_NOTIFY_FILE_REQUEST_INACTIVE';

export const ACTION_DRAG_FORM_FIELD_START = 'ACTION_DRAG_FORM_FIELD_START';
export const ACTION_DRAG_FORM_FIELD_END = 'ACTION_DRAG_FORM_FIELD_END';

export const ACTION_DRAG_FORM_FIELD_ENTER_DROPZONE =
  'ACTION_DRAG_FORM_FIELD_ENTER_DROPZONE';
export const ACTION_DRAG_FORM_FIELD_LEFT_DROPZONE =
  'ACTION_DRAG_FORM_FIELD_LEFT_DROPZONE';

export const ACTION_SET_FORM_ELEMENT_TESTIDS =
  'ACTION_SET_FORM_ELEMENT_TESTIDS';
export const ACTION_STORE_INSERT_INDEX = 'ACTION_STORE_INSERT_INDEX';
export const ACTION_UPDATE_GROUP_LAYOUT = 'ACTION_UPDATE_GROUP_LAYOUT';
export const ACTION_TOGGLE_FIELD_COLUMN = 'ACTION_TOGGLE_FIELD_COLUMN';
export const ACTION_UPDATE_ITEM_HEIGHT_IN_LAYOUT =
  'ACTION_UPDATE_ITEM_HEIGHT_IN_LAYOUT';
export const ACTION_STORE_FORM_ELEMENT_HEIGHT =
  'ACTION_STORE_FORM_ELEMENT_HEIGHT';
export const ACTION_TOOLBAR_DROPDOWN_OPEN = 'ACTION_TOOLBAR_DROPDOWN_OPEN';
export const ACTION_TOOLBAR_DROPDOWN_CLOSE = 'ACTION_TOOLBAR_DROPDOWN_CLOSE';
export const ACTION_UPDATE_FORM_LOGIC = 'ACTION_UPDATE_FORM_LOGIC';

export const ACTION_TOGGLE_SHOW_UPLOAD_FILE_DESCRIPTION =
  'ACTION_TOGGLE_SHOW_UPLOAD_FILE_DESCRIPTION';

export const FOLDER_PICKER_COPY_MODE = 'FOLDER_PICKER_COPY_MODE';
export const FOLDER_PICKER_SELECT_MODE = 'FOLDER_PICKER_SELECT_MODE';
export const ACTION_SELECT_FORM_UPLOAD_FOLDER =
  'ACTION_SELECT_FORM_UPLOAD_FOLDER';
export const ACTION_CLEAR_FORM_UPLOAD_FOLDER =
  'ACTION_CLEAR_FORM_UPLOAD_FOLDER';

export const ACTION_SET_BUILDER_ERROR = 'ACTION_SET_BUILDER_ERROR';
export const ACTION_INJECT_JOI_VALIDATION_ERRORS =
  'ACTION_INJECT_JOI_VALIDATION_ERRORS';
export const ACTION_CLEAR_LOGIC_ERRORS = 'ACTION_CLEAR_LOGIC_ERRORS';
export const ACTION_DELETE_LOGIC_ITEM = 'ACTION_DELETE_LOGIC_ITEM';
export const ACTION_CLEAR_ALL_LOGIC_ITEMS = 'ACTION_CLEAR_ALL_LOGIC_ITEMS';
export const ACTION_SET_LOGIC_ERRORS = 'ACTION_SET_LOGIC_ERRORS';
export const ACTION_DELETE_LOGIC_ERRORS = 'ACTION_DELETE_LOGIC_ERRORS';

export const initialFolder: Path & {
  isActionDisabled?: boolean;
  isSharedFolder?: boolean;
  isExternallyOwned?: boolean;
} = {
  id: '0',
  name: '',
  isActionDisabled: true,
  isExternallyOwned: false,
};

export const defaultDragDropNewFormFieldState: DragDropNewFormFieldState = {
  field: '',
  draggingNewFormField: false,
  inDropzone: false,
  dropIndex: 0,
  groupId: '',
};

export const defaultContentPickerState: ContentPickerState = {
  folderPath: [initialFolder],
  items: [],
  searchResults: [],
  requestInProgress: false,
  searchInProgress: false,
  onSelectInProgress: false,
  pageCount: 1,
  pageNumber: 1,
};

export const defaultUploadLogoModalState = {
  dataUrl: '',
  errorMessage: null,
  file: null,
  uploadLogoInProgress: false,
};

export const defaultThemePanelState = {
  defaultColor: rawColorHex(BOX_BLUE),
  colorPickerValue: rawColorHex(BOX_BLUE),
  selectedColorOnColorPickerOpen: {
    key: '',
    value: '',
  },
  colors: PALETTE_COLORS,
  logos: {
    adminColorLogo: {
      key: ADMIN_COLOR_LOGO,
      value: null,
    },
    adminDefaultLogo: {
      key: ADMIN_DEFAULT_LOGO,
      value: null,
    },
    uploadedLogo: {
      key: null,
      value: null,
    },
  },
  showColorPicker: false,
  stagedLogoPath: '',
  colorPickerError: null,
} as const;

export const defaultState: State = {
  deactivatedBadFileRequest: false,
  editableDescriptions: [],
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2739
  savedFileRequest: DEFAULT_EMPTY_FILE_REQUEST,
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
  workingFileRequest: DEFAULT_EMPTY_FILE_REQUEST,
  allMetadataTemplates: [],
  activeMetadataTemplates: [],
  metadataTemplateError: false,
  isClearMetadataTemplateModalOpen: false,
  isMetadataPickerOpen: false,
  isExitModalOpen: false,
  isFieldSelectorDrawerOpen: false,
  isItemDragging: false,
  isDeleteFileRequestModalOpen: false,
  isFolderPickerModalOpen: false,
  folderPickerModalMode: FOLDER_PICKER_COPY_MODE,
  folderPickerModalSelectedUploadId: '',
  isMetadataFieldShown: false,
  isThemePanelOpen: false,
  isUploadLogoModalOpen: false,
  needToScrollToBottom: false,
  allMetadataFieldsSelected: false,
  showFieldDescription: {},
  oneRequiredUploadFieldRemaining: false,
  elementInFocus: '',
  elementWithOpenDropdown: '',
  elementBeingDragged: '',
  successMessage: null,
  warnMessage: null,
  errorMessage: null,
  isShareModalOpen: false,
  logicErrors: {},
  notificationOptions: {
    duration: 'short',
    onCloseAction: '',
    onMessageAction: null,
  },
  saveInProgress: false,
  saveBeforeShareInProgress: false,
  saveBeforePreviewInProgress: false,
  settingsPanelOpen: false,
  settingsPanelData: {
    fieldId: '',
  },
  selectedColor: '',
  isMetadataEnabled: false,
  resin: {
    recordAction: () => {},
  },
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2739
  resinEvent: {},
  contentPickerState: defaultContentPickerState,
  uploadLogoModalState: defaultUploadLogoModalState,
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
  themePanelState: defaultThemePanelState,
  dragDropNewFormFieldState: defaultDragDropNewFormFieldState,
  formElementsHeightState: {},
  formElementTestids: {},
  stagedThemeUploadedLogo: null,
};
